/* eslint-disable react-hooks/exhaustive-deps */
import { EQ, GT, GTE, IS_NOT, LT, LTE, } from "../../../misc/RuleObjectTypes";
import React, { useCallback, useEffect, useState } from "react";
import ServiceWrapper from "../../../../../../Services/ServiceWrapper";
import AuthManager from "Common/AuthManager";
import AppSettings from "Settings/AppSettings";
import Select from "react-select";
import { debounce } from "lodash";

const FilterCondition = ({ element, position, reduceFilters, categoryAttributeSet, filterCount, }) => {
  
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [searchValue, setSearchValue] = useState('');
  const [page, setPage] = useState(1);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [noResults, setNoResults] = useState(false);
  
  useEffect(() => {
    if (element?.attrID) {
      getAttributeValues(element?.attrID, page, searchValue);
    }
  }, [element.attrID, page, searchValue]);

  const getAttributeValues = async (attributeId, page, searchString = '') => {
    try {
      const res = await ServiceWrapper.doPost(
        `${api_base_url}get_attribute_values?page=${page}&limit=10&search=${searchString}`,
        {attribute_ids: [attributeId]},
        null,
        AuthManager.getGmsToken()
      );
      const attributeValues = res?.data?.data[0]?.attribute_values ?? [];
      handleAttributeResponse(attributeValues);
    } catch (error) {
      console.log("getAttributeValues ~ error:", error);
      setOptions([]);
    } finally {
      setIsLoading(false);
    }
  }

  const handleAttributeResponse = (response) => {
    const options = (response || []).map(item => ({ value: item.id, label: item.value }));
  
    if (page === 1 && element?.AttrValueId !== 0) {
      const isAttributeIdPresent = options.some(option => option.value === element.AttrValueId);
      const updatedOptions = isAttributeIdPresent
        ? options
        : [{ value: element.AttrValueId, label: element?.AttrValueName ?? '' }, ...options];

      setOptions(prevData => (page === 1 ? updatedOptions : [...prevData, ...updatedOptions]));
    } else {
      const filteredAttribute = options.filter(option => option.value !== element.AttrValueId);
      setOptions(prevData => (page === 1 ? filteredAttribute : [...prevData, ...filteredAttribute]));
    }

    setNoResults(options.length === 0);
  }

  const loadMoreOptions = async () => {
    if (!noResults) {
      setPage(prevPage => prevPage + 1);
    } else {
      setIsLoading(false)
    }
  };

  const debouncedLoadMoreOptions = useCallback(
    debounce(() => loadMoreOptions(), 500),
    [page]
  );

  const debouncedSearch = debounce((value) => {
    setSearchValue(value);
    setPage(1); 
  }, 500);

  const onInputChange = (input) => {
    if (input === '') {
      setPage(1);
    }
    debouncedSearch(input);
  };

  const handleMenuScrollToBottom = () => {
    setIsLoading(true);
    debouncedLoadMoreOptions();
  };

  const handleAttributeChange = (ev) => {
    resetState();
    reduceFilters({ type: "UPDATE_ATTR", attrID: ev.target.value, attrName: ev.target.options[ev.target.selectedIndex].text, position: position, });
  }

  const handleAttributeValueChange = (ev) => {
    reduceFilters({ type: "UPDATE_LOV_ID", AttrValueId: ev.value, AttrValueName: ev.label, position: position,});
  }

  const handleOperatorChange = (ev) => {
    reduceFilters({ type: "UPDATE_CONDITION_OP", position: position, conditionOpName: ev.target.options[ev.target.selectedIndex].text, conditionOperator: ev.target.value, });
  }

  const resetState = () => {
    setOptions([]);
    setNoResults(false);
    setPage(1);
    setSearchValue('');
  }

  const customStyles = {
    option: (provided, state) => ({ ...provided, textAlign: 'left', }),
    control: (provided) => ({ ...provided, textAlign: 'left', }),
  };

  if (element) {
    return (
      <div className="filter-condition">
        <div className="filter-left-bracket" />
        <div className="filter-label tw-text-sm tw-text-[#090A42] ">
          when
        </div>
        <div className="attr-selector tw-text-sm tw-font-medium">
          <select
            className="shadow-none form-select drop-down-dm tw-ps-3"
            value={element.attrID}
            onChange={(ev) => { handleAttributeChange(ev);}}>
            <option defaultValue hidden>
              Please Select
            </option>
            {categoryAttributeSet &&
              categoryAttributeSet.map((el) => {
                return (
                  <option value={el.id} key={el.id}>
                    {el.name}
                  </option>
                );
              })}
          </select>
        </div>
        <div className="op-selector val-selector">
          <select
            className="tw-px-2 "
            value={element.conditionOperator}
            onChange={(ev) => { handleOperatorChange(ev); }}>
            <option selected hidden>
              Please Select
            </option>
            <option value={GT}>{">"}</option>
            <option value={LT}>{"<"}</option>
            <option value={GTE}>{">="}</option>
            <option value={LTE}>{"<="}</option>
            <option value={EQ}>{"=="}</option>
            <option value={IS_NOT}>{"!="}</option>
          </select>
        </div>
        <Select
          className="tw-outline-none"
          options={options} 
          styles={customStyles}
          onMenuScrollToBottom={handleMenuScrollToBottom}
          isLoading={isLoading}
          onInputChange={(input) => onInputChange(input)}
          value={element.AttrValueId ? {value: element.AttrValueId, label: element.AttrValueName} : null}
          onChange={(ev) => { handleAttributeValueChange(ev); }}
          placeholder={'Select Attribute'}
          maxMenuHeight={220}
          menuPlacement="auto"
          isClearable={false}
          components={{ IndicatorSeparator: () => null, }}
        />
        <div className="filter-btn">
          {filterCount > 1 ? (
            <button
              className="delete-button"
              onClick={() => {
                reduceFilters({
                  type: "REMOVE_FILTER_CONDITION",
                  position: position,
                });
              }}
            >
              <i
                className="fa fa-minus"
                aria-hidden="true"
                style={{ color: "rgb(9, 28, 170)" }}
              />
            </button>
          ) : null}
        </div>
        <div className="filter-right-bracket" />
        <div className="filter-add-btn filter-btn">
          <button
            className="delete-button"
            onClick={() => {
              reduceFilters({
                type: "ADD_FILTER_CONDITION",
                position: position,
              });
            }}
          >
            <i
              className="fa fa-plus"
              aria-hidden="true"
              style={{ color: "rgb(9, 28, 170)" }}
            />
          </button>
        </div>
      </div>
    );
  } else return null;
};

export default FilterCondition;